"use strict";
const isTextClamped = elm => elm.scrollHeight > (elm.clientHeight + 10);
const initializeShowLess = () => {
    // remove block if empty / remove buttons if the text is not clamped
    $(".show-less").each((i, el) => {
        let $el = $(el);
        let $wrapper = $el.closest(".show-less-wrapper");

        $el.contents().each((index, content) => {
            if (content.nodeType === Node.COMMENT_NODE) {
                $(content).remove();
            }
        });

        if ($.trim($el.html()).length === 0) {
            $wrapper.hide();
        }

        if (!isTextClamped(el)) {
            $wrapper.addClass("no-buttons");
        }
    });
};

module.exports = {
    init: function () {
        initializeShowLess();

        $("body").on("click", ".show-less-expand, .show-less-hide", function (e) {
            let $this = $(e.currentTarget);
            $this.closest(".show-less-wrapper").toggleClass("expanded");
        });

        $("body").on("showMore:init", () => {
            initializeShowLess();
        });
    }
};
